module.exports = __webpack_public_path__ + "static/img/cabecera.ee19b67.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/proveedores-en/cabecera.jpg
// module id = 8wsf
// module chunks = 0